export default __webpack_public_path__ + "static/media/logo.00b1c0c7.svg";